import { render, staticRenderFns } from "./GruaForm.vue?vue&type=template&id=5a181c9f&scoped=true"
import script from "./GruaForm.vue?vue&type=script&lang=js"
export * from "./GruaForm.vue?vue&type=script&lang=js"
import style0 from "./GruaForm.vue?vue&type=style&index=0&id=5a181c9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a181c9f",
  null
  
)

export default component.exports